var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M76.6,231.9c-3.4,0-6.1-2.7-6.1-6.1V30.2c0-3.4,2.7-6.1,6.1-6.1c3.4,0,6.1,2.7,6.1,6.1v195.6C82.7,229.2,80,231.9,76.6,231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M11.8,161c2.4-2.4,6.3-2.4,8.6,0l60.5,60.5c2.4,2.4,2.4,6.3,0,8.6c-2.4,2.4-6.3,2.4-8.6,0l-60.5-60.5C9.4,167.2,9.4,163.3,11.8,161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M140.9,161.5c-2.4-2.4-6.2-2.4-8.6,0l-60,60c-2.4,2.4-2.4,6.2,0,8.6c2.4,2.4,6.2,2.4,8.6,0l60-60C143.2,167.7,143.2,163.9,140.9,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M179.2,231.9c-3.4,0-6.1-2.7-6.1-6.1V30.2c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1v195.6C185.3,229.2,182.6,231.9,179.2,231.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M113.7,94.5c2.4,2.4,6.3,2.4,8.7,0l61.1-60c2.4-2.4,2.4-6.2,0-8.6c-2.4-2.4-6.3-2.4-8.7,0l-61.1,60C111.3,88.3,111.3,92.1,113.7,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M244.2,93.9c-2.4,2.4-6.3,2.4-8.7,0L175,34.4c-2.4-2.4-2.4-6.2,0-8.5c2.4-2.4,6.3-2.4,8.6,0l60.6,59.6C246.6,87.8,246.6,91.6,244.2,93.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.a766a155a9a82136e72f7ba0b45d5f56.svg";
export { ForwardRef as ReactComponent };